import { api } from "./client";

export async function getRecords(game = "all") {
  const res = await api.get("/records/", { params: { game } });
  return res.data;
}

/**
 * Games that can appear in the records board, for the filter dropdown.
 *
 * Comes from the backend's RECORD_GAMES registry rather than a hardcoded list,
 * so a game added there shows up here without a second edit. A game only
 * appears once it has winners logic, so the filter never offers an option that
 * returns nothing.
 */
export async function getRecordGames() {
  const res = await api.get("/records/games");
  return res.data;
}
